import React from 'react';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import { SOCIAL_FRONTEND_URL } from '../../../config';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerMain}>
          
          {/* Column 1: About & Social */}
          <div className={styles.footerAbout}>
            <div className={styles.logo}>Build Start</div>
            <p>Connecting homeowners with verified local tradespeople. We make home improvement projects simple, secure, and successful for everyone involved.</p>
            <div className={styles.socialIcons}>
              <a href={SOCIAL_FRONTEND_URL} target="_blank" rel="noopener noreferrer" className={styles.socialIcon}><FaFacebookF /></a>
              <a href={SOCIAL_FRONTEND_URL} target="_blank" rel="noopener noreferrer" className={styles.socialIcon}><FaTwitter /></a>
              <a href={SOCIAL_FRONTEND_URL} target="_blank" rel="noopener noreferrer" className={styles.socialIcon}><FaLinkedinIn /></a>
              <a href={SOCIAL_FRONTEND_URL} target="_blank" rel="noopener noreferrer" className={styles.socialIcon}><FaInstagram /></a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className={styles.footerLinks}>
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/home-landing-pure">For Home Owners</Link></li>
              <li><Link to="/business-landing">For Professionals</Link></li>
              <li><Link to="/map-search-v2">Search Jobs</Link></li>
              <li><a href={SOCIAL_FRONTEND_URL} target="_blank" rel="noopener noreferrer">Social Media</a></li>
              <li><Link to="/resources-hub">Education Resources</Link></li>
              <li><Link to="/contact-support">Contact Support</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms and Conditions</Link></li>
            </ul>
          </div>

          {/* Column 3: Directory */}
          <div className={styles.footerLinks}>
            <h4>Directory</h4>
            <ul>
              <li><Link to="/directory/airconditioning">Airconditioning</Link></li>
              <li><Link to="/directory/builder">Builders</Link></li>
              <li><Link to="/directory/concreter">Concreters</Link></li>
              <li><Link to="/directory/architect">Architects</Link></li>
              <li><Link to="/directory/Quantity Surveyor">Quantity Surveyors</Link></li>
              <li><Link to="/directory/landscaper">Landscapers</Link></li>
              <li><Link to="/directory/all">View All Categories...</Link></li>
            </ul>
          </div>

          {/* Column 4: Resources */}
          <div className={styles.footerLinks}>
            <h4>Resources</h4>
            <ul>
              <li><Link to="/resources-hub">Terminology</Link></li>
              <li><Link to="/resources-hub">Flow Charts</Link></li>
              <li><Link to="/resources-hub">Design Tips</Link></li>
              <li><Link to="/resources-hub">How tos</Link></li>
              <li><Link to="/contact-support">Support</Link></li>
              <li><Link to="/resources-hub">Our Process</Link></li>
              <li><Link to="/resources-hub">Resource library</Link></li>
              <li><Link to="/help-faq">Help & FAQ</Link></li>
            </ul>
          </div>

        </div>

        <div className={styles.footerBottom}>
          <p>© Copyright 2026 https://buildstart.au | All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
